export default __webpack_public_path__ + "static/media/image_mappcode_qr_ean.fb8d4b0c.png";